import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { getCompetitionDisplayName } from '../../utils/competitionDisplayName';

/**
 * @param {{ competitions: Array, value: string, onChange: (slug: string) => void, disabled?: boolean, id?: string }} props
 */
export function CompetitionSelector({
  competitions,
  value,
  onChange,
  disabled,
  id = 'competition-select',
  className = ''
}) {
  const { language } = useLanguage();

  const selectValue =
    competitions.find(
      (c) => c.slug?.toLowerCase() === String(value || '').toLowerCase()
    )?.slug ?? value;

  return (
    <div className={`relative min-w-[min(100%,220px)] ${className}`}>
      <select
        id={id}
        aria-label="Competition"
        value={selectValue}
        disabled={disabled || competitions.length === 0}
        onChange={(e) => onChange(e.target.value)}
        className="tap-target w-full cursor-pointer appearance-none rounded-xl border border-zinc-200 bg-white py-2.5 pl-3 pr-10 text-sm font-semibold text-zinc-800 shadow-sm transition hover:border-zinc-300 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/25 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {competitions.length === 0 ? (
          <option value={value}>{value}</option>
        ) : (
          competitions.map((c) => (
            <option key={c._id} value={c.slug}>
              {getCompetitionDisplayName(c, language)}
            </option>
          ))
        )}
      </select>
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </span>
    </div>
  );
}
